// @ts-ignore
import sbjs from 'sourcebuster';

export const sourcebuster = sbjs;
